import { ModuleRegistry, ServerSideRowModelModule } from 'ag-grid-enterprise';
import { observer } from 'mobx-react';
import useStore from '../../../../store';
import { Button } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AgGridReact } from 'ag-grid-react';
import Message from '../../../../config/Message';
import { ServerGridConfig } from '../../../../config/GridConfig';
import { faEye, faLink, faPencil, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

const ListComponent = observer((props) => {
	ModuleRegistry.registerModules([ServerSideRowModelModule]);
	const { openEditModal, openDeleteModal } = props;
	const { ACCOMMODATION, MERCHANT, AUTH } = useStore();
	const { user } = AUTH;
	dayjs.extend(utc);
	dayjs.extend(timezone);

	const MerchantLinkRenderer = (props) => {
		const handleClick = () => {
			const rawId = props.data?.id;
			if (!rawId) return;

			try {
				// 1. Get the Base URL from the environment file
				const baseUrl = process.env.REACT_APP_BOOKING_URL;

				// 2. Encode the ID (Using btoa for Base64 format)
				const b64Id = btoa(rawId);

				// 3. URL encode to handle special characters (+, /, =)
				const encodedId = encodeURIComponent(b64Id);

				// 4. Construct the dynamic URL
				const finalUrl = `${baseUrl}?merchantid=${encodedId}`;

				window.open(finalUrl, "_blank");
			} catch (error) {
				console.error("Link generation failed:", error);
				// Fallback for unexpected characters in the ID
				const baseUrl = process.env.REACT_APP_BOOKING_URL;
				window.open(`${baseUrl}?merchantid=${encodeURIComponent(rawId)}`, "_blank");
			}
		};

		return (
			<span
				style={{
					color: "#1677ff",
					cursor: "pointer",
					textDecoration: "underline"
				}}
				onClick={handleClick}
			>
				{props.value}
			</span>
		);
	};

	const ActionRenderer = (props) => {
		return (
			<div className="action-column">
				{/* <Button type="text" title={'View'} className="viewIcon">
					<FontAwesomeIcon icon={faEye} />
				</Button> */}
				<Button
					type="text"
					title={'Edit'}
					className="editIcon"
					onClick={() => {
						ACCOMMODATION.ReadMerchant(props.data.id);
						openEditModal();
					}}
				>
					<FontAwesomeIcon color="#1723ad" icon={faPencil} />
				</Button>
				<Button
					type="text"
					title={'Delete'}
					className="deleteIcon"
					onClick={() => {
						openDeleteModal(props.data);
					}}
				>
					<FontAwesomeIcon icon={faTrashAlt} color={'red'} />
				</Button>
				{(user && user.id) === process.env.REACT_APP_SUPER_ADMIN_ID && (
					<Button
						type="text"
						title={'Proxy login'}
						onClick={() => window.open(`https://${process.env.REACT_APP_MERCHANT_BASE_URL || ''}?username=${user?.id}&shortname=${props.data.shortName}`, "_blank")}
					>
						<FontAwesomeIcon icon={faLink} color={'green'} />
						<link to={props.data.url}></link>
					</Button>
				)}
			</div>
		);
	};

	const colDefs = [
		{
			headerName: 'Merchant Name',
			field: 'merchantName',
			sort: 'asc',
			minWidth: 140,
			cellRenderer: 'MerchantLinkRenderer'
		},
		{
			headerName: 'Short Name',
			field: 'shortName',
			minWidth: 140,
		},
		{
			headerName: 'State Name',
			field: 'stateName',
			minWidth: 140,
			sortable: false,
		},
		{
			headerName: 'City Name',
			field: 'cityName',
			minWidth: 140,
			sortable: false,
		},
		{
			headerName: 'Contact',
			field: 'phoneNo',
			minWidth: 140,
		},
		{
			headerName: 'Active Plan',
			field: 'subscriptionName',
			minWidth: 100,
		},
		{
			headerName: 'Merchant Role',
			field: 'merchantRoleName',
			minWidth: 100,
		},
		{
			headerName: 'Created On',
			field: 'createdOn',
			minWidth: 100,
			valueFormatter: ({ value }) => {
				return value
					? dayjs.utc(value).tz('Asia/Kolkata').format('DD/MM/YYYY') : '';
			},
		},
		{
			headerName: 'Created By',
			field: 'createdByName',
			minWidth: 100,
		},
		{
			headerName: 'Actions',
			field: 'actions',
			cellRenderer: 'ActionRenderer',
			pinned: 'right',
			sortable: false,
			filter: false,
			minWidth: 120,
			width: 120,
		},
	];

	return (
		<div
			className="ag-theme-quartz" // applying the grid theme
			style={{ height: 'calc(100vh - 140px)' }} // the grid will fill the size of the parent container>
		>
			<AgGridReact
				onGridReady={ACCOMMODATION.setupGrid}
				headerHeight={35}
				columnDefs={colDefs}
				defaultColDef={ServerGridConfig.defaultColDef}
				columnTypes={ServerGridConfig.columnTypes}
				overlayNoRowsTemplate={Message().noRecord}
				gridOptions={ServerGridConfig.options}
				rowSelection={'multiple'}
				components={{
					ActionRenderer,
					openEditModal,
					MerchantLinkRenderer,
				}}
			/>
		</div>
	);
});
export default ListComponent;
